import React, { useState } from "react";
import MomentUtils from "@date-io/moment";

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker
} from "@material-ui/pickers";


const ICTimeInput = props => {
  const [selectedDate, handleSelectDateChange] = useState(
    props.defaultTime ? props.defaultTime: null
  );

  const handleDateChange = timeDate => {
    handleSelectDateChange(timeDate);
    props.handleChange(timeDate);
  };

  return (
    <div
      className={
        "ic-time-input " + (props.className ? props.className : "")
      }
    >
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <KeyboardTimePicker
          value={selectedDate}
          disabled={props.disabled}
          className="w-100"
          onChange={handleDateChange}
          KeyboardButtonProps={{
            "aria-label": "change time"
          }}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default ICTimeInput;
